import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { FileDownloadUrlResponse } from '@/repositories/generated';

const response: FileDownloadUrlResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['行数', '項目名', 'エラーメッセージ'],
    ['1行目', 'ウォレットサービスID', 'ウォレットサービスIDは3桁で入力してください。'],
  ]),
};
export const bulkImportDownloadError = http.get(
  createMockEndpoint('/bulk_import/:id/download/error'),
  async ({ params }) => {
    if (params.id === '7') {
      return HttpResponse.json({
        error: {
          code: 'ERR-D999-0007',
          message: 'URLが間違っているか、ページが存在しません。',
        },
      }, { status: 404 });
    }
    await delay(500);

    return HttpResponse.json(response, { status: 200 });
  },
);
